import { report, type Place } from "./checks.ts";
import type { ConeShape } from "./types.ts";

/**
 * The longest wind-up a cone may carry, in ticks: a `u8`, past any strip's length.
 */
export const MAX_IMPACT_TICKS = 255;

/**
 * Checks what a cone ability holds beside its shape (ADR-095's amendment of 2026-10-10): a wind-up shorter than its
 * cooldown, so a caster never holds two blows pending, and none on an ability that plays a combo or a chain, which
 * land in the act's tick and are players' abilities.
 *
 * @param place Where to report.
 * @param shape The checked cone.
 * @param ability The ability's cooldown, combo and chain, null or undefined where they were missing or wrong.
 * @returns True when it passes.
 */
export function coneAbilityChecks(place: Place, shape: ConeShape, ability: { readonly cooldownTicks: number | null; readonly combo: unknown; readonly chain: unknown }): boolean {
  if (shape.impactTicks === 0) {
    return true;
  }
  let ok = true;
  if (ability.cooldownTicks !== null && ability.cooldownTicks <= shape.impactTicks) {
    report(place, `shape.impactTicks is ${shape.impactTicks}, and the cooldown ${ability.cooldownTicks} must outlast it, so a caster never holds two blows pending`);
    ok = false;
  }
  if (ability.combo !== null && ability.combo !== undefined) {
    report(place, "a cone with a combo lands in its act's tick: its impactTicks must be 0");
    ok = false;
  }
  if (ability.chain !== null && ability.chain !== undefined) {
    report(place, "a cone with a chain lands in its act's tick: its impactTicks must be 0");
    ok = false;
  }
  return ok;
}
